import {
  effectiveWeightSchemeSelectValue,
  weightSchemeOptionValue,
} from 'js/utils/rubric';
import {
  isOrgTeamRubricCustomSchemeId,
  ORG_TEAM_RUBRIC_CUSTOM_SCHEME_ID,
} from 'js/utils/orgTeamRubricScheme';

import {
  flattenOrgTreeForWeights,
  isEditableWeightRow,
  isTreeRootWeightRow,
  normalizeOrgForWeights,
} from './orgWeightsUtils';

export const ORG_RUBRIC_SCHEMES_QUERY_IDLE = 'org-rubric-weight-schemes/__idle';

export function orgManageOrgQueryId(orgId) {
  return `organization-manage-${orgId}`;
}

export function orgRubricSchemesQueryId(orgId, rubricId) {
  return `org-rubric-weight-schemes/${orgId}/${rubricId}`;
}

export function orgManageRubricsPath(workspaceId, orgId, rubricId) {
  const base = `/w/${workspaceId}/orgs/${encodeURIComponent(
    orgId
  )}/manage/rubrics`;
  return rubricId ? `${base}/${encodeURIComponent(rubricId)}` : base;
}

export function orgManageTeamCustomWeightsPath(
  workspaceId,
  orgId,
  rubricId,
  teamId
) {
  return `/w/${workspaceId}/orgs/${encodeURIComponent(
    orgId
  )}/manage/rubrics/${encodeURIComponent(rubricId)}/teams/${encodeURIComponent(
    teamId
  )}/custom-weights`;
}

export function findTeamRowInOrgTree(organization, teamId) {
  const rows = flattenOrgTreeRows(organization);
  return rows.find((r) => r.type === 'team' && String(r.id) === String(teamId));
}

export function teamSchemeRowById(teamsPayload) {
  const rows = teamsPayload?.teams ?? [];
  return new Map(rows.map((row) => [row.team_id, row]));
}

export function selectValueForTeamRow(row, document) {
  if (!row) return '';
  const scheme = row.org_override
    ? row.org_weight_scheme
    : row.team_weight_scheme;
  return effectiveWeightSchemeSelectValue(scheme, document);
}

/** True when the row uses an alternate scheme (not document default weights). */
export function isNonDefaultSchemeSelectValue(selectValue) {
  return String(selectValue ?? '').trim() !== '';
}

/** Build PATCH body for a scheme dropdown change. */
export function patchForSchemeChange(row, nextSelectValue, document) {
  const teamScheme = effectiveWeightSchemeSelectValue(
    row?.team_weight_scheme,
    document
  );
  const normalizedNext = String(nextSelectValue ?? '').trim();
  const normalizedTeam = String(teamScheme ?? '').trim();

  if (normalizedNext === normalizedTeam && row?.org_override) {
    return { inherit: true };
  }

  if (normalizedNext === normalizedTeam && !row?.org_override) {
    return null;
  }

  return {
    weight_scheme:
      normalizedNext === ''
        ? null
        : isOrgTeamRubricCustomSchemeId(nextSelectValue)
        ? ORG_TEAM_RUBRIC_CUSTOM_SCHEME_ID
        : nextSelectValue,
  };
}

export { ORG_TEAM_RUBRIC_CUSTOM_SCHEME_ID };

export function flattenOrgTreeRows(organization) {
  const tree = normalizeOrgForWeights(organization);
  return tree ? flattenOrgTreeForWeights(tree) : [];
}

export { isEditableWeightRow, isTreeRootWeightRow, weightSchemeOptionValue };
